<template>
  <div id="app">
    <!-- FOND GLOBAL -->
    <video
      id="global-bg"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
      src="/img/cover2.mp4"
    ></video>

    <!-- site -->
    <router-view />
  </div>
</template>

<script setup>
document.addEventListener("visibilitychange", () => {
  const v = document.getElementById("global-bg")
  if (!v) return
  if (document.visibilityState === "visible") {
    v.play().catch(() => {})
  }
})
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* VIDÉO DE FOND FIXE */
#global-bg {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: -9999;
  pointer-events: none;
  background: #000; /* coupe instantanément le blanc */
  display: block;
  opacity: 1;
  transform: translateZ(0); /* force GPU */
}
</style>